import { getUserLanguage } from '@aqx-core/common/i18n';

import { ELanguageQueryString, mapLangQueryStringToTLang } from './languages';
import { TAppLanguageISOCountryCode } from './types';

/**
 * Checks if a language is supported by the company
 * @param language - Language code to check
 * @param supportedLanguages - Array of supported language codes from company config
 * @returns true if language is supported, false otherwise
 */
export const isLanguageSupported = (
  language: TAppLanguageISOCountryCode,
  supportedLanguages?: TAppLanguageISOCountryCode[] | null
): boolean => {
  if (!supportedLanguages || supportedLanguages.length === 0) {
    return false;
  }

  return supportedLanguages.includes(language);
};

export const getQueryLangFromTLang = (): ELanguageQueryString => {
  let currentQueryLang: ELanguageQueryString = ELanguageQueryString.EN;
  const currentLang = getUserLanguage();
  Object.entries(mapLangQueryStringToTLang).forEach(([queryLang, appLang]: [string, TAppLanguageISOCountryCode]) => {
    if (appLang === currentLang) {
      currentQueryLang = queryLang as ELanguageQueryString;
    }
  });
  return currentQueryLang;
};
